import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { Icon as f } from "@blueprintjs/core";
import { IconNames as u } from "@blueprintjs/icons";
import l from "classnames";
import { useState as h, useEffect as g } from "react";
import v from "react-animate-height";
import "./main.scss";
const E = ({
  closeable: e = !1,
  onRemoveContainerClick: t = void 0,
  expandOnRender: a = !1,
  className: m = void 0,
  style: n = void 0,
  children: p = void 0
}) => {
  const [s, i] = h(a);
  g(() => {
    i(!1);
  }, []);
  const c = (o) => {
    i(!0), o.stopPropagation();
  };
  return /* @__PURE__ */ d(
    v,
    {
      duration: 300,
      height: s ? 0 : "auto",
      onHeightAnimationEnd: (o) => {
        s && (t == null || t(o));
      },
      animateOpacity: !0,
      children: [
        e && /* @__PURE__ */ r(
          f,
          {
            className: "sds_input-container__remove-button",
            icon: u.CROSS,
            onClick: c,
            title: "Remove"
          }
        ),
        /* @__PURE__ */ r("div", { className: l("sds_input-container", m), style: n, children: p })
      ]
    }
  );
};
export {
  E as FormInputContainer
};
//# sourceMappingURL=index.js.map
